import React from 'react';
import ReactApexChart from 'react-apexcharts';

function VitalApexChart(props) {

    const series = [...props.dataList]

    const options = {
        chart: {
            type: 'line',
            dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 30,
                blur: 10,
                opacity: 0.2
            },
            toolbar: {
                show: false
            },

            background: '#0D0D0D',
        },
        dataLabels: {
            style: {
                fontSize: '12px',
                fontWeight: 'bold',
            },
            background: {
                enabled: true,
                foreColor: 'red',
                borderRadius: 2,
                padding: 4,
                opacity: 0.9,
                borderWidth: 1,
                borderColor: 'red'
            },
        },
        stroke: {
            curve: 'straight',
            width: 2.5,
        },
        title: {
            text: 'Vitals Graph',
            align: 'left'
        },
        theme: {
            mode: 'dark',
            palette: 'palette8',
            monochrome: {
                enabled: false,
                color: '#255aee',
                shadeTo: 'light',
                shadeIntensity: 0.85
            },
        },
        grid: {
            borderColor: '#333333',
            xaxis: {
                lines: {
                    show: false,
                }
            },
            yaxis: {
                lines: {
                    show: true,
                }
            },
        },
        markers: {
            size: 0,
        },
        xaxis: {
            categories: [...props.timeData],
            title: {
                text: 'Time'
            }
        },
        yaxis: {
            title: {
                text: ''
            },
        },
        legend: {
            show: false,
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: 5,
            radius: 0,
            showForZeroSeries: true,
            onItemClick: {
                toggleDataSeries: true,
            },
            markers: {
                radius: 0,
            }
        },
        animations: {
            enabled: false,
            easing: 'linear',
            speed: 0,
            animateGradually: {
                enabled: false,
                delay: 0
            },
            dynamicAnimation: {
                enabled: false,
                speed: 350
            }
        }
    }

    return (
        <div>
            <ReactApexChart options={options} series={series} type="line" height={470} />
        </div>
    );
}

export default VitalApexChart;